import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { FilterOption } from '@/types/filters.types';
import { getMembershipManagementOptions } from '@/services/memberships-management.service';
import { MEMBERSHIP_STATUS_OPTIONS } from '@/pages/memberships/membershipsManagementShared';

export function useMembershipFilterOptions(opts?: { enabled?: boolean }): Record<string, FilterOption[]> {
  const enabled = opts?.enabled ?? true;

  const { data: options } = useQuery({
    queryKey: ['membership-management-options'],
    queryFn: getMembershipManagementOptions,
    staleTime: 300_000,
    enabled,
  });

  return useMemo<Record<string, FilterOption[]>>(() => ({
    'membership-type': (options?.templates ?? []).map((t) => ({ value: String(t.value), label: t.label })),
    'membership-status': MEMBERSHIP_STATUS_OPTIONS.map((item) => ({ value: item.value, label: item.label })),
    facility: (options?.facilities ?? []).map((f) => ({ value: String(f.value), label: f.label })),
  }), [options]);
}
